export default "__VITE_ASSET__2vNt81Ae__"